import { render } from "./ServicesExpandedMobile.vue?vue&type=template&id=62238e5c&scoped=true"
import script from "./ServicesExpandedMobile.vue?vue&type=script&lang=js"
export * from "./ServicesExpandedMobile.vue?vue&type=script&lang=js"

import "./ServicesExpandedMobile.vue?vue&type=style&index=0&id=62238e5c&scoped=true&lang=css"

import exportComponent from "/home/tantonj/Documents/GitHub/TantonSoftwareSolutions/tantonsoftwaresolutions/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62238e5c"]])

export default __exports__